import { InfoIcon } from "@components/icons";
import { FC, memo } from "react";
import "./form-error.scss";

interface FormErrorComponentProps {
  errorMessage?: string;
}

const FormErrorComponent: FC<FormErrorComponentProps> = ({ errorMessage }) => {
  if (!errorMessage) {
    return null;
  }
  return (
    <span className="error-message" role="alert">
      <InfoIcon color="#FF5C29" />
      {errorMessage}
    </span>
  );
};

export const FormError = memo(FormErrorComponent);
